import { reportError } from "../basket-v2/errorReporting";
import { EventEmitter, trackCheckoutEvent } from "../../../utils";
import { events } from "../../../scripts/constants";

const defaultMessage = "Tickets have not been added to the basket, please try again.";
const defaultCheckoutEventName = "basket_add_failed";


export function showTicketBasketFailure(message: string | null = defaultMessage, checkoutEventName: string | null = defaultCheckoutEventName) {
  
  const errorMessage =
    `<p>${message}</p>` +
    "<p>If this error persists please contact us <a href='mailto:ticketing@thejockeyclub.co.uk' target='_blank'>here</a> or Call <a href='tel:03445793019' target='_blank'>0344 579 3019</a></p>";

  reportError("Basket", errorMessage);

  trackCheckoutEvent({
    message_name: checkoutEventName || defaultCheckoutEventName,
    message_text: message || defaultMessage,
    message_type: "error",
    checkout_step: "ticket_listing"
  });
}

EventEmitter.on(events.SHOW_TICKET_BASKET_FAIL, (data: { messageText: string; messageName: string }) => {  
  showTicketBasketFailure(data.messageText, data.messageName);
});
